<template>
    <rkm-modal
        extra-large
        ref="Modal"
        title="Cadastro de RAAS"
    >
        <Form
            :id="id"
            @save="handleExit"
            ref="Form"
        />

        <template v-slot:footer="{ cancel }">
            <rkm-button
                :disabled="!!loading"
                @click="cancel"
                color="secondary"
            >
                {{ exportado ? 'Fechar' : 'Cancelar' }}
            </rkm-button>

            <rkm-button
                v-if="!exportado"
                :disabled="!!loading"
                @click="$refs.Form.save()"
                color="primary"
            >
                Salvar
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
// Components.
import Form from './Form'

// Vuex.
import { mapGetters } from 'vuex'

export default {
    components: { Form },
    computed: {
        ...mapGetters({ loading: 'getLoading' }),
    },
    data: () => ({
        id: null,
        exportado: false,
    }),
    methods: {
        open(item) {

            this.id = item.id
            this.exportado = item.exportado

            this.$refs.Modal.show()
        },
        handleExit() {

            this.$emit('close')
            this.$refs.Modal.hide()
        },
    },
}
</script>